'use client';

import { useMemo } from 'react';
import { Box, Image, ImageProps } from '@chakra-ui/react';
import { ZmyleLogo } from 'assets/icons/ZmyleLogo';
import { useNetwork } from 'context/network';
import { useAppLayoutContext } from './AppLayoutContext';

export interface NetworkLogoProps extends ImageProps {}

export const NetworkLogo = (props: NetworkLogoProps) => {
  const { src } = props;

  const { network } = useNetwork();

  const { variant } = useAppLayoutContext();

  const logoUrl = useMemo(() => {
    if (src) return src;

    return variant === 'error' ? network?.logoWideVsUrl : network?.logoWideUrl;
  }, [network, src, variant]);

  if (!logoUrl) {
    return (
      <Box height={['3rem', '3rem', '4.678rem']} objectFit="cover">
        <ZmyleLogo />
      </Box>
    );
  }

  return (
    <Image
      src={logoUrl}
      alt="Network Logo"
      height={['3rem', '3rem', '4.678rem']}
      objectFit="cover"
      alignSelf="flex-start"
      ml="1.5rem"
      {...props}
    />
  );
};
